import { render, staticRenderFns } from "./SfxListItem.vue?vue&type=template&id=68352a3a&scoped=true"
import script from "./SfxListItem.vue?vue&type=script&lang=js"
export * from "./SfxListItem.vue?vue&type=script&lang=js"
import style0 from "./SfxListItem.vue?vue&type=style&index=0&id=68352a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68352a3a",
  null
  
)

export default component.exports